import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { EventService } from '../../shared/event.service';

@Component({
  selector: 'app-cart-abandonment-warning',
  templateUrl: './cart-abandonment-warning.component.html',
  styleUrls: ['./cart-abandonment-warning.component.less']
})
export class CartAbandonmentWarningComponent implements AfterViewInit {

  private allowAbandonmentSource = new Subject<boolean>();
  allowAbandonment$: Observable<boolean> = this.allowAbandonmentSource.asObservable();

  constructor(private eventService: EventService,
              private router: Router) { }

  ngAfterViewInit(): void {
    this.eventService.focusField('cart-abandonment-warning-div');
  }

  allowAbandonment() {
    this.allowAbandonmentSource.next(true);
  }

  goToCart() {
    this.allowAbandonmentSource.next(false);
    this.router.navigate([{ outlets: { view: 'cart' }}]);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/cart/cart-abandonment-warning/cart-abandonment-warning.component.ts